export default {
  showRequiredIndicator : true,
}
